import React from "react";
import { cn } from "@/lib/utils";

function CompactSliderView({ label, value, ticks, icons }) {
  const ActiveIcon = icons[value];
  const activeLabel = ticks[value];

  return (
    <div className="flex items-center justify-between">
      <span className="text-xs text-neutral-600">{label}</span>
      <div className="flex items-center gap-1.5">
        {ActiveIcon && <ActiveIcon className="h-3.5 w-3.5 text-orange-600" />}
        <span className="text-xs font-medium text-neutral-800">{activeLabel}</span>
      </div>
    </div>
  );
}

export { CompactSliderView };
